import { MapMarkerClusterer } from './map-marker-clusterer.model';

export class UnassignedPickupMapMarkerCluster extends MapMarkerClusterer {}
